import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { SiLeetcode, SiCodeforces, SiGeeksforgeeks } from 'react-icons/si';

const profiles = [
  {
    platform: 'LeetCode',
    url: 'https://leetcode.com/u/utkarsh_101/',
    icon: <SiLeetcode size={54} color="#FFA116" />,
    color: '#FFA116',
  },
  // {
  //   platform: 'Codeforces',
  //   url: 'https://codeforces.com/profile/utkarshcodes',
  //   icon: <SiCodeforces size={54} color="#1F8ACB" />,
  //   color: '#1F8ACB',
  // },
  {
    platform: 'GeeksforGeeks',
    url: 'https://www.geeksforgeeks.org/user/utkarshsrivastava01/',
    icon: <SiGeeksforgeeks size={54} color="#2F8D46" />,
    color: '#2F8D46',
  },
  {
    platform: 'GitHub',
    url: 'https://github.com/codeByUtkarsh',
    icon: <FaGithub size={54} color="#24292e" />,
    color: '#24292e',
  },
  {
    platform: 'LinkedIn',
    url: 'https://www.linkedin.com/in/theutkarshsrivastava/',
    icon: <FaLinkedin size={54} color="#0077b5" />,
    color: '#0077b5',
  },
];

const CodingProfiles = () => (
  <div className="container section">
    <h2 className="mb-5 fw-bold text-center coding-heading">Coding Profiles</h2>
    <div className="coding-icons-row d-flex flex-wrap justify-content-center align-items-center gap-4 gap-md-5 w-100">
      {profiles.map((profile) => (
        <a
          key={profile.platform}
          href={profile.url}
          target="_blank"
          rel="noopener noreferrer"
          className="coding-icon-box d-flex flex-column align-items-center justify-content-center text-decoration-none"
          style={{ color: profile.color }}
        >
          <span className="coding-icon mb-2">{profile.icon}</span>
          <span className="coding-icon-label mt-1 fw-semibold">{profile.platform}</span>
        </a>
      ))}
    </div>
  </div>
);

export default CodingProfiles;
